import { useCallback, useEffect, useRef, useState } from "react"
import { addSignature, getSignature } from "../../../services/usersService";

export const useSignature = () => {
    const isMountedRef = useRef(false);
    const [signatureUrl, setSignatureUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    

    const load = useCallback(() => {
        const _fetch = async () => {
            try {
                setLoading(true);
                const blob = await getSignature();
                if(!isMountedRef.current)
                    return;
                const url = URL.createObjectURL(blob);
                setSignatureUrl(url);
            }
            finally {
                if(!isMountedRef.current)
                    return;
                setLoading(false);
            }
        }
        _fetch();
    }, []);

    const change = useCallback((signature: string) => {
        const _fetch = async () => {
            try {
                setLoading(true);
                await addSignature(signature);
                if(!isMountedRef.current)
                    return;
                load();
            }
            catch { 
                if(!isMountedRef.current)
                    return;
                setLoading(false);  
            }
        }
        _fetch();
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { signatureUrl, loading, load, change };
} 